import React, { useCallback } from 'react';
import { useAnalytics, useAuthManager, useFeatureFlags } from '@funtech-int/yango-shared';

import { Modal } from '@/shared/components/Modal/Modal';

import { useCounterOffer } from '../../hooks/useCounterOffer';
import { createCounterOfferAnalytics } from '../../lib/counterOfferAnalytics';
import { featureFlagsScheme } from '../../lib/featureFlags';

import { CounterOfferModal } from './CounterOfferModal';
import styles from './CounterOfferOnHome.module.css';

const CounterOfferContent = () => {
    const { isCounterOfferVisible, hideCounterOffer, counterOffer, baseOffer, paymentPlace } =
        useCounterOffer();
    const counterOfferAnalytics = useAnalytics(createCounterOfferAnalytics);

    const handleHideModal = useCallback(() => {
        counterOfferAnalytics.cancelButtonNavigated();
        hideCounterOffer();
    }, [counterOfferAnalytics, hideCounterOffer]);

    if (!isCounterOfferVisible || !counterOffer) {
        return null;
    }

    return (
        <Modal onHideModal={handleHideModal} rounded={false} className={styles.modal}>
            <CounterOfferModal
                counterOffer={counterOffer}
                baseOffer={baseOffer}
                paymentPlace={paymentPlace}
                onClose={hideCounterOffer}
            />
        </Modal>
    );
};

export const CounterOfferOnHome = () => {
    const { flags } = useFeatureFlags(featureFlagsScheme);
    const { isAuthorized } = useAuthManager();
    const shouldShowCounterOffer = flags.get('shouldShowCounterOffer');

    if (!shouldShowCounterOffer || !isAuthorized) {
        return null;
    }

    return <CounterOfferContent />;
};
